export const conversionConstants = {
  SET_CONVERSION_FIELD: 'SET_CONVERSION_FIELD',
  SELECT_CONVERSION_FIELD: 'SELECT_CONVERSION_FIELD',
  RESET_CONVERSION_STORE: 'RESET_CONVERSION_STORE',
  SET_CONVERSION_TYPE: 'SET_CONVERSION_TYPE',
  SET_CONVERSION_TABLE_SELECTION: 'SET_CONVERSION_TABLE_SELECTION',
};
